export default __webpack_public_path__ + "static/logo_6-1b43a709f40f4050deba7d47b1009e2a.jpg";